import React, { useState, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Input, NumericTextBox } from '@progress/kendo-react-inputs';
import { Label } from '@progress/kendo-react-labels';
import './dialog-usersSigners.css';
import AutoCompleteSignerContainer from '../../actions/autocomplete-signer/AutoCompleteSignerContainer';
import { Tooltip } from '@progress/kendo-react-tooltip';
import {
  GridSelectionHLPure,
  CheckBoxHLPure,
  SearchBarHLPure,
  DialogFormHLPure,
  ButtonHLPure,
  ButtonAddHLPure,
  InputHLPure,
} from '../../pures';

function DialogUserNegotiation(props) {
  const { t } = useTranslation();
  //For Adialog
  const {
    nameAddBtn,
    titleDialog,
    cancel,
    descriptionActive,
    dataUsers = [],
    searchValue,
    setSearchValue,
    cellColumnOne,
    searchPlaceholder,
    titleDialog2,
    openSecondDialog,
    setOpenSecondDialog,
    inputEmailChange,
    inputEmail,
    inputName,
    inputNameChange,
    inputLastName,
    inputLastNameChange,
    handleSubmit,
    createMember,
    errorInEmail,
  } = props;

  const [selectedUser, setSelectedUser] = useState({});

  const styleGrid = {
    fontFamily: 'Quicksand, sans-serif',
    maxHeight: 'calc(50px * 5.5)',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    borderRight: '1px solid rgb(200, 200, 200) !important',
    maxHeight: '312px'
  }

  return (
    <>
      {!openSecondDialog ? (
        <DialogFormHLPure
          className='invitation-modal'
          titleDialog={titleDialog}
          descriptionActive={descriptionActive}
          descriptionDialog={t('dialogSignerList2.invitationmessage')}
          textBtnCancel={t('button.cancel')}
          cancel={cancel}
          saveBtn={t('button.accept')}
          handleSubmit={handleSubmit}
        >
          <div className='dialogSigner-formButtons'>
            <ButtonAddHLPure
              nameBtn={nameAddBtn}
              onClickBtn={setOpenSecondDialog}
              iconAdd={true}
            />
            <SearchBarHLPure
              placeholder={searchPlaceholder}
              onSearchChange={setSearchValue}
              searchValue={searchValue}
            />
          </div>
          <div className='dialog-invitation-grid'>
            <GridSelectionHLPure
              skip={0}
              take={6}
              dataGrid={dataUsers}
              filter={true}
              styleGrid={styleGrid}
              onFilterChange={props.filterChange}
              onSelectedItem={setSelectedUser}
              titleRow1={t('negotiation.view.grid.title.collaborators')}
              pageable={false}
              cellColumnOne={cellColumnOne}
            />
          </div>
        </DialogFormHLPure>
      ) : (
        <DialogFormHLPure
          titleDialog={titleDialog2}
          cancel={setOpenSecondDialog}
          textBtnCancel={t('button.back')}
          saveBtn={t('button.save')}
          handleSubmit={createMember}
        >
          {' '}
          <div
            style={{
              marginBottom: '14px',
              lineHeight: '1',
              textAlign: 'left',
            }}
          >
            <InputHLPure
              typeInput='email'
              labelInput={t('dialogSignerList2.email')}
              inputTypeBox={false}
              valueInput={inputEmail}
              handleChangeInput={inputEmailChange}
              inputActive
            />
            {errorInEmail && (
              <span className='hint-message-error'>
                {t('dialogSignerList2.errorEmailNotvalid')}
              </span>
            )}
          </div>
          <div
            style={{
              marginBottom: '14px',
              lineHeight: '1',
              textAlign: 'left',
            }}
          >
            <Label className='dialog-signers-labels'>
              {t('dialogSignerList2.name')}
            </Label>
            <div>
              <Input
                className='input-add-colaborator'
                type='name'
                name='nameSigner'
                minLength={2}
                value={inputName}
                onChange={inputNameChange}
              />
            </div>
          </div>
          <div
            style={{
              marginBottom: '14px',
              lineHeight: '1',
              textAlign: 'left',
            }}
          >
            <Label className='dialog-signers-labels'>
              {t('dialogSignerList2.lastName')}
            </Label>
            <Input
              className='input-add-colaborator'
              type='name'
              name='lastNameSigner'
              minLength={2}
              value={inputLastName}
              onChange={inputLastNameChange}
            />
          </div>
        </DialogFormHLPure>
      )}
    </>
  );
}

export { DialogUserNegotiation as default };
